var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 25.00 25.00",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#11202b",
    d: " M 9.29 0.00 L 15.80 0.00 Q 24.50 0.05 25.00 7.79 L 25.00 13.10 Q 24.51 20.53 16.87 20.83 Q 16.38 20.85 16.07 21.23 L 13.04 25.00 L 11.87 25.00 L 8.94 21.24 Q 8.64 20.85 8.15 20.84 Q 0.44 20.54 0.00 13.00 L 0.00 7.67 Q 0.61 -0.04 9.29 0.00 Z M 14.27 8.56 C 13.02 9.92 9.81 11.26 11.57 13.78 Q 11.90 14.26 12.48 14.19 Q 13.71 14.03 13.86 12.74 A 1.42 1.37 -18.1 0 1 14.33 11.85 C 15.38 10.92 16.78 10.38 17.19 8.92 Q 18.01 6.01 15.33 4.70 Q 11.37 2.76 8.71 6.45 Q 7.77 7.76 8.97 8.81 A 1.18 1.18 0.0 0 0 10.70 8.62 L 11.41 7.65 Q 12.04 6.78 13.11 6.78 Q 13.66 6.78 14.10 7.08 A 0.98 0.98 0.0 0 1 14.27 8.56 Z M 14.02 16.95 A 1.52 1.52 0.0 0 0 12.50 15.43 A 1.52 1.52 0.0 0 0 10.98 16.95 A 1.52 1.52 0.0 0 0 12.50 18.47 A 1.52 1.52 0.0 0 0 14.02 16.95 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.2471cb66056df4244d3bf9f3e65e756d.svg";
export { ForwardRef as ReactComponent };